import React from 'react';

export const DuskBreakersLogo = () => {
  return (
    <svg
      width="239"
      height="16"
      viewBox="0 0 239 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5304_7360)">
        <path
          d="M8.32222 14.6174C8.32222 14.6174 8.32222 14.5774 8.32222 14.5019C8.32222 14.5796 8.32222 14.6174 8.32222 14.6174C7.62444 10.7796 5.90222 9.17741 0 8.45297V15.6307H9.78444C15.6778 15.6307 18.1867 13.4196 18.1867 8.51741V8.29297C11.0311 8.92852 9.07556 10.4619 8.32222 14.6174Z"
          fill="white"
        />
        <path
          d="M8.32222 1.35708C9.07556 5.51931 11.0422 7.04819 18.1867 7.68375V7.48153C18.1867 2.57708 15.6778 0.34375 9.78444 0.34375H0V7.52153C5.89333 6.80153 7.62667 5.20153 8.32222 1.35708Z"
          fill="white"
        />
        <path
          d="M20.3735 7.43486V0.34375H25.3002V7.87264C25.3002 10.866 26.7735 11.7638 29.5135 11.7638C32.2535 11.7638 33.7269 10.866 33.7269 7.87264V0.34375H38.6535V7.43486C38.6535 13.5349 35.6602 15.9749 29.5135 15.9993C23.3669 15.9993 20.3735 13.5371 20.3735 7.43486Z"
          fill="white"
        />
        <path
          d="M40.9336 10.8422V10.52H45.8136V10.82C45.8136 11.8333 46.8025 12.34 49.8891 12.3156C53.2047 12.3156 54.0336 11.9467 54.0336 11.0956V10.98C54.0336 10.3578 53.5958 10.1044 52.4914 10.0356L46.9203 9.64444C43.4203 9.41333 41.118 8.19333 41.118 5.06222V4.94667C41.118 1.86444 43.1891 0 49.7047 0C56.6336 0 58.3603 2.09556 58.3603 5.04222V5.36444H53.4558V5.08889C53.4558 4.12222 52.558 3.66222 49.5647 3.66222C46.5958 3.66222 45.9269 4.00667 45.9269 4.69778V4.76667C45.9269 5.43333 46.4336 5.71111 47.6758 5.82667L53.4314 6.19556C57.1847 6.44889 58.8425 7.80667 58.8425 10.6156V10.7533C58.8425 14.16 56.678 15.98 49.8869 15.98C42.5669 15.9778 40.9336 13.7667 40.9336 10.8422Z"
          fill="white"
        />
        <path
          d="M73.7842 15.6304L69.3176 9.62153L66.4642 12.1326V15.6326H61.6064V0.34375H66.4642V6.65264L73.1642 0.34375H79.8176L73.0264 6.33042L80.0242 15.6304H73.7842Z"
          fill="white"
        />
        <path
          d="M100.604 10.9349V11.1415C100.604 13.9726 98.6464 15.6304 94.1131 15.6304H82.3486V0.34375H94.482C98.0264 0.34375 99.5686 1.49486 99.5686 3.91264V4.09708C99.5464 5.66153 98.7864 6.85931 97.4286 7.43486C99.4997 7.87264 100.582 9.07042 100.604 10.9349ZM94.6197 5.24819C94.5975 4.58153 94.2509 4.18819 93.1242 4.18819H87.1842V6.55931H93.0086C94.2064 6.55931 94.6197 6.09931 94.6197 5.45486V5.24819ZM95.402 10.2437C95.3797 9.43708 94.8264 9.04597 93.4686 9.04597H87.1842V11.786H93.4931C94.8042 11.786 95.4042 11.2793 95.4042 10.4726V10.2437H95.402Z"
          fill="white"
        />
        <path
          d="M115.409 15.6304L112.118 10.8415H108.273V15.6304H103.416V0.34375H114.12C118.356 0.34375 120.542 1.70153 120.542 5.40819V5.75264C120.542 8.37708 119.482 9.82819 117.411 10.4482L121.187 15.6282H115.409V15.6304ZM108.271 4.39708V7.18375H113.911C115.062 7.18375 115.522 6.74597 115.522 5.94153V5.61931C115.522 4.79042 115.038 4.39931 113.911 4.39931H108.271V4.39708Z"
          fill="white"
        />
        <path
          d="M138.845 4.46597H128.485V6.51486H138.04V9.39264H128.485V11.5104H138.845V15.6304H123.627V0.34375H138.845V4.46597Z"
          fill="white"
        />
        <path
          d="M155.282 15.6304L154.2 13.3504H146.211L145.129 15.6304H140.064L147.938 0.34375H152.473L160.347 15.6304H155.282ZM147.844 9.94375H152.564L150.216 4.99486L147.844 9.94375Z"
          fill="white"
        />
        <path
          d="M174.16 15.6304L169.693 9.62153L166.838 12.1326V15.6326H161.98V0.34375H166.838V6.65264L173.538 0.34375H180.191L173.4 6.33042L180.398 15.6304H174.16Z"
          fill="white"
        />
        <path
          d="M197.94 4.46597H187.58V6.51486H197.111V9.39264H187.58V11.5104H197.94V15.6304H182.722V0.34375H197.94V4.46597Z"
          fill="white"
        />
        <path
          d="M213.135 15.6304L209.844 10.8415H206V15.6304H201.142V0.34375H211.847C216.082 0.34375 218.269 1.70153 218.269 5.40819V5.75264C218.269 8.37708 217.209 9.82819 215.138 10.4482L218.913 15.6282H213.135V15.6304ZM205.998 4.39708V7.18375H211.638C212.789 7.18375 213.249 6.74597 213.249 5.94153V5.61931C213.249 4.79042 212.764 4.39931 211.638 4.39931H205.998V4.39708Z"
          fill="white"
        />
        <path
          d="M220.202 10.8405V10.5183H225.082V10.8183C225.082 11.8316 226.073 12.3383 229.158 12.3139C232.473 12.3139 233.302 11.945 233.302 11.0939V10.9783C233.302 10.3561 232.864 10.1028 231.76 10.0339L226.189 9.64276C222.689 9.41165 220.387 8.19165 220.387 5.06054V4.94498C220.387 1.86054 222.458 -0.00390625 228.973 -0.00390625C235.902 -0.00390625 237.629 2.09165 237.629 5.03832V5.36054H232.724V5.08498C232.724 4.11832 231.827 3.65832 228.833 3.65832C225.864 3.65832 225.195 4.00276 225.195 4.69387V4.76276C225.195 5.42943 225.702 5.7072 226.944 5.82276L232.7 6.19165C236.453 6.44498 238.111 7.80276 238.111 10.6116V10.7494C238.111 14.1561 235.947 15.9761 229.155 15.9761C221.838 15.9761 220.202 13.765 220.202 10.8405Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_5304_7360">
          <rect width="238.113" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
